import React, { Component } from "react";
import {
    Route,
    BrowserRouter,
    Switch
} from "react-router-dom";
import Cookies from 'universal-cookie';
import { db } from "./services/firebase";
import Chat from "./Chat";
import Name from "./Name";
import Offline from "./Offline";
import Blocked from "./Blocked";

export default class App extends Component{
  constructor(props){
    super(props);
    this.cookies = new Cookies();
    this.state = {
      name: false,
      online: true,
      supportID: this.cookies.get('supportID'),
      blocked: false
    }
    this.db_Online = db.ref('online');
    this.db_Chats = db.ref('chats');
  }

  componentDidMount(){
    const supportID = this.state.supportID;

    this.db_Online.on('value', snap => {
      this.setState({online: snap.val()});
    });

    if(supportID){
      this.db_Chats.child(supportID).child('blocked').on('value', snap => {
        this.setState({blocked: snap.val()});
      });
    }

  }

  render() {
    return (
        <BrowserRouter>
            <Switch>
                <Route path="/" component={(this.state.online)?((this.state.blocked)?Blocked:(this.state.supportID)?Chat:Name):Offline} />
            </Switch>
        </BrowserRouter>
    );
  }
}
